import {Component} from '@angular/core';

@Component({
  selector: 'call-node',
  templateUrl: './call-node.component.html'
})
export class CallNodeComponent {
    node
}
